import React from 'react'
import Fragment from '../common/fragment'


function FragmentBL(props) {
  return (
    <Fragment pos="ll" {...props}>
      <p>
      Señora, ¡excúsanos! No sabemos criar abejas. Construimos muñecos para ofrecer
sacrificios a gestos inexistentes. Para ver (ver) la disolución de la cera (cera), un
atardecer apaciguado de las pasiones. Intentaremos volar. Algunos solo zumbaran,
en silencio (silencio).
      </p>
    </Fragment>
  )
}


export default FragmentBL
